import ShowPasswordResetUpdateInput from './ShowPasswordResetUpdateInput';

export default ShowPasswordResetUpdateInput;
